// extracted by mini-css-extract-plugin
export default {"innerWrapper":"EA-z","tooltipWrapper":"FA-z","icon":"GA-z","tooltip":"HA-z","content":"IA-z"};